import Form from '@/classes/Form';
import formMixin from '@/mixins/form';

export default {
    mixins: [formMixin],

    props: {
        eventType: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            form: new Form({
                event: '',
                email: '',
            })
        }
    },

    computed: {
        isProcessing() {
            return this.form.processing;
        },

        events() {
            return this.$store.state.eventDocument.events[this.eventType];
        },

        selectedEvent() {
            return _.find(this.events, item => item.slug === this.form.event);
        },

        error() {
            return this.$store.state.eventDocument.error;
        },

        hasError() {
            return ! _.isEmpty(this.error);
        },

        formPayload() {
            return _.assign({}, this.form.getRequestData(), {event: this.selectedEvent.id});
        }
    },

    methods: {
        attemptSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (! valid) {
                    this.scrollToError(formName);
                    return false;
                }

                this.form.processing = true;

                this.handleSubmit();
            });
        },

        reset() {
            this.form.email = '';
        }
    },

    created() {
        this.$store.dispatch('eventDocument/fetchEventsByType', this.eventType);
    }
}